
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  created(){
    this.modelLocal = this.model;
  },
  methods: {},
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 345, left: 85},
        {name: "tractorFirstAxle", top: 345, left: 300}, 
        {name: "tractorSecondAxle", top: 345, left: 400}, 
        {name: "semitrailerFirstAxle", top: 345, left: 630},
        {name: "semitrailerSecondAxle", top: 345, left: 700}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 152, left: 208, width: 40},
        {name: "tractorAxlesDistanceSecond", top: 152, left: 263, width: 56},
        {name: "tractorAxlesDistanceThird", top: 152, left: 353, width: 56},
        {name: "semitrailerAxlesDistanceFirst", top: 152, left: 668, width: 56},
        {name: "tractorCabinAxlesDistance", top: 290, left: 195, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 113, left: 420, width: 56}],
    };
  },
});
